import { useSelector } from 'react-redux';
import ChatInput from '../../../components/shared/chat-input/ChatInput';
import ChatContent from '../chats/ChatContent';
import { useParams } from 'react-router-dom';
import { RootState } from '../../../app/store';

const Chats = () => {
	const {id} = useParams();
	const { showChatInput, clarifyMode } = useSelector(
		(state: RootState) => state.chats
	);
	
	return (
		<div className='flex flex-col h-[calc(100vh-200px)]'>
			<div className=' justify-center items-center mt-auto mx-auto max-w-full'>
				{id && <ChatContent />}
				{(showChatInput || clarifyMode) && <ChatInput />}
			</div>
		</div>
	)
}

export default Chats;